import z from 'zod';

import { client } from '~shared/api';

import { RoleDto, RoleDtoSchema } from '../dto';

export async function fetchListRoles(sectionId: number) {
	const data = await client.get(`/role/section/${sectionId}`);
	return z.array(RoleDtoSchema).parse(data);
}

export async function updateRolesBySection(sectionId: number, roles: RoleDto[]) {
	await client.put(`/role/section/${sectionId}`, roles);
}
